import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";

import MsGraph from "../../../../utils/MsGraphApiCall";
import { translationKeys } from "../../../models/app-translation-keys";
import { LoadingPage } from "../FullScreenInformation/Loading";

export const PageLogout: FunctionComponent = () => {
  const { t } = useTranslation();
  const { instance: pca } = useMsal();

  useEffect(() => {
    MsGraph.handleLogout(pca);
  });

  return <LoadingPage loadingInformation={t(translationKeys.global.logout)} />;
};
